import React from 'react';
import PropTypes from 'prop-types'; // troll

import { UserAccess } from '@weezevent/nacre';

import { usePermissions } from '../../../../user/permissions';

export default function UserRightsRender({ children, allow = ['admin'] }) {
    const permissions = usePermissions();

    return (
        <UserAccess
            allow={allow}
            capacities={permissions.roles}
            render={is_allowed => {
                if (!is_allowed) {
                    return null;
                }

                return children;
            }}
        />
    );
}

UserRightsRender.propTypes = {
    children: PropTypes.node, // omg i was not expecting that
    allow: PropTypes.array // omg i was not expecting that
};
